// Generated by purs version 0.13.0
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var DamageYouM = (function () {
    function DamageYouM(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    DamageYouM.create = function (value0) {
        return function (value1) {
            return new DamageYouM(value0, value1);
        };
    };
    return DamageYouM;
})();
var DamageYouHarmlessM = (function () {
    function DamageYouHarmlessM(value0) {
        this.value0 = value0;
    };
    DamageYouHarmlessM.create = function (value0) {
        return new DamageYouHarmlessM(value0);
    };
    return DamageYouHarmlessM;
})();
var HitAWallM = (function () {
    function HitAWallM() {

    };
    HitAWallM.value = new HitAWallM();
    return HitAWallM;
})();
var AttackM = (function () {
    function AttackM(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    AttackM.create = function (value0) {
        return function (value1) {
            return new AttackM(value0, value1);
        };
    };
    return AttackM;
})();
var AttackHarmlessM = (function () {
    function AttackHarmlessM(value0) {
        this.value0 = value0;
    };
    AttackHarmlessM.create = function (value0) {
        return new AttackHarmlessM(value0);
    };
    return AttackHarmlessM;
})();
var AttackKillM = (function () {
    function AttackKillM(value0) {
        this.value0 = value0;
    };
    AttackKillM.create = function (value0) {
        return new AttackKillM(value0);
    };
    return AttackKillM;
})();
var NothingToPickUp = (function () {
    function NothingToPickUp() {

    };
    NothingToPickUp.value = new NothingToPickUp();
    return NothingToPickUp;
})();
var PickedUpItem = (function () {
    function PickedUpItem(value0) {
        this.value0 = value0;
    };
    PickedUpItem.create = function (value0) {
        return new PickedUpItem(value0);
    };
    return PickedUpItem;
})();
var DropItem = (function () {
    function DropItem(value0) {
        this.value0 = value0;
    };
    DropItem.create = function (value0) {
        return new DropItem(value0);
    };
    return DropItem;
})();
var DoNotHave = (function () {
    function DoNotHave() {

    };
    DoNotHave.value = new DoNotHave();
    return DoNotHave;
})();
var DoNotKnowHowToUse = (function () {
    function DoNotKnowHowToUse() {

    };
    DoNotKnowHowToUse.value = new DoNotKnowHowToUse();
    return DoNotKnowHowToUse;
})();
var Healed = (function () {
    function Healed() {

    };
    Healed.value = new Healed();
    return Healed;
})();
var FullHealth = (function () {
    function FullHealth() {

    };
    FullHealth.value = new FullHealth();
    return FullHealth;
})();
var LightningScrollHitYourself = (function () {
    function LightningScrollHitYourself() {

    };
    LightningScrollHitYourself.value = new LightningScrollHitYourself();
    return LightningScrollHitYourself;
})();
var TargetingOutOfFov = (function () {
    function TargetingOutOfFov() {

    };
    TargetingOutOfFov.value = new TargetingOutOfFov();
    return TargetingOutOfFov;
})();
var FireballExplodes = (function () {
    function FireballExplodes(value0) {
        this.value0 = value0;
    };
    FireballExplodes.create = function (value0) {
        return new FireballExplodes(value0);
    };
    return FireballExplodes;
})();
var BurnSelf = (function () {
    function BurnSelf(value0) {
        this.value0 = value0;
    };
    BurnSelf.create = function (value0) {
        return new BurnSelf(value0);
    };
    return BurnSelf;
})();
var BurnM = (function () {
    function BurnM(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    BurnM.create = function (value0) {
        return function (value1) {
            return new BurnM(value0, value1);
        };
    };
    return BurnM;
})();
var Targeting = (function () {
    function Targeting(value0) {
        this.value0 = value0;
    };
    Targeting.create = function (value0) {
        return new Targeting(value0);
    };
    return Targeting;
})();
var TargetNoEnemy = (function () {
    function TargetNoEnemy() {

    };
    TargetNoEnemy.value = new TargetNoEnemy();
    return TargetNoEnemy;
})();
var CastConfusion = (function () {
    function CastConfusion(value0) {
        this.value0 = value0;
    };
    CastConfusion.create = function (value0) {
        return new CastConfusion(value0);
    };
    return CastConfusion;
})();
var NoStairs = (function () {
    function NoStairs() {

    };
    NoStairs.value = new NoStairs();
    return NoStairs;
})();
var DownstairsRest = (function () {
    function DownstairsRest() {

    };
    DownstairsRest.value = new DownstairsRest();
    return DownstairsRest;
})();
var TakeOn = (function () {
    function TakeOn(value0) {
        this.value0 = value0;
    };
    TakeOn.create = function (value0) {
        return new TakeOn(value0);
    };
    return TakeOn;
})();
var TookOff = (function () {
    function TookOff(value0) {
        this.value0 = value0;
    };
    TookOff.create = function (value0) {
        return new TookOff(value0);
    };
    return TookOff;
})();
var LogMessage = (function () {
    function LogMessage(value0) {
        this.value0 = value0;
    };
    LogMessage.create = function (value0) {
        return new LogMessage(value0);
    };
    return LogMessage;
})();
var Die = (function () {
    function Die(value0) {
        this.value0 = value0;
    };
    Die.create = function (value0) {
        return new Die(value0);
    };
    return Die;
})();
var Target = (function () {
    function Target(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Target.create = function (value0) {
        return function (value1) {
            return new Target(value0, value1);
        };
    };
    return Target;
})();
var LevelUp = (function () {
    function LevelUp(value0) {
        this.value0 = value0;
    };
    LevelUp.create = function (value0) {
        return new LevelUp(value0);
    };
    return LevelUp;
})();
var withAction = function (result) {
    return function (action) {
        return {
            result: result,
            actions: [ action ]
        };
    };
};
var target = function (f) {
    return function (msg) {
        return function (v) {
            return {
                result: v.result,
                actions: Data_Array.cons(new Target(v.result, f))(Data_Array.cons(new LogMessage(new Targeting(msg)))(v.actions))
            };
        };
    };
};
var openLevelUp = function (v) {
    return {
        result: v.result,
        actions: Data_Array.cons(new LevelUp(v.result))(v.actions)
    };
};
var onResult = function (f) {
    return function (v) {
        return {
            result: f(v.result),
            actions: v.actions
        };
    };
};
var inactive = function (result) {
    return {
        result: result,
        actions: [  ]
    };
};
var die = function (v) {
    return {
        result: v.result,
        actions: Data_Array.cons(new Die(v.result))(v.actions)
    };
};
var addActions = function (moreActions) {
    return function (v) {
        return {
            result: v.result,
            actions: Data_Semigroup.append(Data_Semigroup.semigroupArray)(moreActions)(v.actions)
        };
    };
};
var addAction = function (action) {
    return function (v) {
        return {
            result: v.result,
            actions: Data_Array.cons(action)(v.actions)
        };
    };
};
module.exports = {
    LogMessage: LogMessage,
    Die: Die,
    Target: Target,
    LevelUp: LevelUp,
    DamageYouM: DamageYouM,
    DamageYouHarmlessM: DamageYouHarmlessM,
    HitAWallM: HitAWallM,
    AttackM: AttackM,
    AttackHarmlessM: AttackHarmlessM,
    AttackKillM: AttackKillM,
    NothingToPickUp: NothingToPickUp,
    PickedUpItem: PickedUpItem,
    DropItem: DropItem,
    DoNotHave: DoNotHave,
    DoNotKnowHowToUse: DoNotKnowHowToUse,
    Healed: Healed,
    FullHealth: FullHealth,
    LightningScrollHitYourself: LightningScrollHitYourself,
    TargetingOutOfFov: TargetingOutOfFov,
    FireballExplodes: FireballExplodes,
    BurnSelf: BurnSelf,
    BurnM: BurnM,
    Targeting: Targeting,
    TargetNoEnemy: TargetNoEnemy,
    CastConfusion: CastConfusion,
    NoStairs: NoStairs,
    DownstairsRest: DownstairsRest,
    TakeOn: TakeOn,
    TookOff: TookOff,
    addAction: addAction,
    addActions: addActions,
    die: die,
    inactive: inactive,
    onResult: onResult,
    withAction: withAction,
    target: target,
    openLevelUp: openLevelUp
};
